import React, { useContext } from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import OperationContext from './context';
import { tooltipPreventOverflowModifiers } from '../../../shared/misc/utils';

const refreshPage = () => {
  setTimeout(() => {
    window.location.reload();
  }, 500);
};

const OperationSubtitle = () => {
  const { operation } = useContext(OperationContext);
  const { t } = useTranslation();
  const { name, loanNumber, phase } = operation;
  let firstLoan = t('na');
  let allLoans = null;
  if (loanNumber && loanNumber[0]) {
    [firstLoan] = loanNumber;
    if (loanNumber[1]) {
      firstLoan += ' ...';
    }
    allLoans = loanNumber.join(' ');
  }

  return (
    <>
      <div className="page-name-subtitle">{name}.</div>
      <div className="page-subtitle">
        <div id="loanCont" style={{ alignItems: 'baseline', whiteSpace: 'nowrap' }}>
          <span id="loan" className="bold">{`${t('LOAN')}: `}</span>
          {firstLoan}
          <span className="divider">/</span>
        </div>
        <div id="statusCont" style={{ alignItems: 'baseline', whiteSpace: 'nowrap' }}>
          <span id="status" className="bold">{`${t('status')}: `}</span>
          {operation.esgStatus}
          <span className="divider">/</span>
        </div>
        <div id="stageCont" style={{ alignItems: 'baseline', whiteSpace: 'nowrap' }}>
          <span id="stage" className="bold">{`${t('stage')}: `}</span>
          {operation.stage}
          <span className="divider">/</span>
        </div>
        <div id="phaseCont" style={{ alignItems: 'baseline', whiteSpace: 'nowrap' }}>
          <span id="phase" className="bold">{`${t('phase')}: `}</span>
          {phase}
        </div>
      </div>
      {operation.relateds && operation.relateds.length > 0 && (
        <div className="page-subtitle">
          <span id="phase" className="bold">
            {`${t('relatedOperations')}:`}&nbsp;
          </span>
          {operation.relateds.map((r, index) => (
            <>
              {index > 0 && <span className="divider">,&nbsp;</span>}
              <Link
                key={r.number}
                to={`/operations/${r.number}`}
                id={r.number}
                className="mt-n2"
                style={{ color: '#0099d6', fontSize: '14px' }}
                onClick={refreshPage}
              >
                <span>{r.number}</span>
              </Link>
            </>
          ))}
        </div>
      )}
      <UncontrolledTooltip
        placement="bottom"
        target="loanCont"
        modifiers={tooltipPreventOverflowModifiers}
      >
        <span id="loan" className="bold">
          {`${t('LOAN')}: `}
        </span>
        <span>{allLoans}</span>
      </UncontrolledTooltip>
    </>
  );
};

export default OperationSubtitle;
